import { useState, useEffect, useContext, useRef } from "react";
import { SideMenu } from "../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../components/data_table/data_table.component";
import OverLay from "../../components/side_menu/overlay_side_menu.component";
import { OverflowSetCustomExample } from "../../components/side_menu/overFlowSet.component";
import { Stack, StackItem } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { Button, MenuList, MenuButton, Divider, Text, Body1Strong, Title3, Body1, Caption1, FluentProvider, Input, Tooltip, Spinner } from "@fluentui/react-components";
import { Filter20Filled, FilterDismiss20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, AddSquare20Regular, Dismiss16Regular, Delete20Regular, Settings20Regular, KeyReset20Regular, Info16Filled } from "@fluentui/react-icons";
import { Breadcrumbs } from "../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../components/dropdown/menu.component";
import { DropdownComponent } from "../../components/dropdown/dropdown.component";
import { ToastComponent } from "../../components/toast/toast.component";
import { GlobalContext } from "../../hooks/globalContext";
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import { RJSFSchema } from '@rjsf/utils';
import { CustomWidgets } from "../../components/form-components";
import validator from '@rjsf/validator-ajv8';
import { Form } from "@rjsf/fluent-ui";
import { Users_func } from "../../api/user/users_func";
import DialogBox from "../../components/dialog/dialog.component";
import { primaryIcon, secondaryIcon, buttonContent, DynamicBoxingCSS, parentHome, wraperStyle, timezoneInfo, SubSectionResponsive, dashboardTheme, BreadcrumbsBorder } from "../../styles/customStyles";
import { Activity_log_func } from "../../api/activity_log/activity_log_func";
import { usePermissionStore } from "../../Store/permissionStore";
import { SkeletonDataTable } from "../../components/skeleton/skeletonDataTable";
import { convertToLocalTimezone, convertUTCToReadableFormat, convertToExcelFormat } from "../../utility/utils";
import FullScreenButton from "../../components/fullscreen/fullScreen.component";
import { DatepickerComponent } from "../../components/picker/datepicker.component";
import { SearchBar } from "../../components/searchbar/searchbar.component";
import { AdministrationPages } from "../../components/side_menu/InlineSidenav";

export const Users = () => {
    const navigate = useNavigate();
    const contextValue: any = useContext(GlobalContext);
    const tenantName = contextValue.tenantName;
    var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const formattedTimeZone = userTimeZone.replace('_', ' ').replace('/', ' / ');
    const [final_data, set_final_data]: any = useState(null);
    const [tableData, setTableData] = useState([]);
    const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
    const [overlayOpen, setOverlayOpen] = useState(false);
    const [searchVal, setSearchVal] = useState("");
    const [filterArray, setFilterArray] = useState<string[]>([]);
    const [dropDownValue1, setDropDownValue1] = useState<any>();
    const [dropDownValue2, setDropDownValue2] = useState<any>();
    const [isfilter, setIsFilter] = useState(false);
    const [filterMenuOpen, setFilterMenuOpen] = useState(false);
    const [isResetDisabled, setResetDisabled] = useState(true);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [exportData, setExportData] = useState([]);
    const [exportDetails, setExportDetails]: any = useState([]);
    const [rowID, setRowID]: any = useState(null);
    const [rowDesc, setRowDesc]: any = useState(null);
    const [formDataUser, setFormDataUser]: any = useState({});
    const [currentSelectedUserFormDetails, setCurrentSelectedUserFormDetails]: any = useState({});
    const [saveUserDetails, setSaveUserDetails] = useState(false)
    const [editUserDetails, setEditUserDetails] = useState(false)
    const [overlayName, setOverlayName] = useState('');
    const [isdeletedisabled, setDeleteDisabled] = useState(true);
    const [deleteUser, setdeleteUser]: any = useState(false);
    const [deleteUserToast, setdeleteUserToast]: any = useState(false);
    const [isRefresh, setIsRefresh]: any = useState(false);
    const [refreshToast, setRefreshToast]: any = useState(false);
    const [isEmailExistsToast, setEmailExistsToast]: any = useState(false);
    const [isToast, setIsToast] = useState(false);
    const [tracker, setTracker] = useState(false);
    const [userActivityData, setUserActivityData] = useState({});
    const [overLayData, setoverLayData]: any = useState([]);
    const [uniquUSerType, setUniqueUserType] = useState(["Local", "SSO", "Nanoheal"]);
    const [uniqueColumn, setUniqueColumn] = useState([]);
    const [exportBtnClicked, setExportBtnClicked] = useState(false);
    const { permissions } = usePermissionStore();
    const [loading, setLoading] = useState(true);
    const [uischema, setUischema] = useState({});
    const [uniqueStatus, setUniqueStatus] = useState([]);
    const [isStatusName, setStatusName] = useState([]);
    const [spinnerLoad, setSpinnerLoad] = useState(true);
    const formRef = useRef(null);
    const [tableColumnsData, setTableColumnsData] = useState([]);
    const [filterColumnsData, setFilterColumnsData] = useState([]);
    const [errorMessage, setErrorMessage] = useState<String>('')
    const [isMailsent, setMailSent]: any = useState(false);
    const [isMailSentToast, setMailSentToast]: any = useState(false)


    useEffect(() => {
        if (!overlayOpen) {
            setFormDataUser(null);
            setRowID(null);
        }
    }, [overlayOpen]);


    const handle = useFullScreenHandle();
    const [siteList, setSiteList] = useState([]);
    useEffect(() => {
        console.log('fetched sitelist : ', siteList.map((val: any) => val.sitename));
    }, [siteList])
    const [roleList, setRoleList] = useState([]);
    const [username, setUsername]: any = useState();
    let name: any;
    useEffect(() => {
        if (overlayOpen) {
            if (formDataUser != undefined) {
                name = formDataUser.firstName;
                setUsername(name);
                console.log("usrnamee", username);
            }
        }
    }, [overlayOpen, formDataUser])
    console.log("form-data-user", formDataUser)
    const roleEnum = roleList?.map((role: any) => role?.role);
    const roleEnumNames = roleList?.map((role: any) => role?.role);


    const saveBtnFunc = () => {
        if (formDataUser == null) {
            //alert("alert form is empty")
        }
        overlayName == 'edit' ? setEditUserDetails(true) : setSaveUserDetails(true);
        setOverlayOpen(false)
    }

    const handleEditData = (data: any) => {
        if (overlayName === 'edit') {
            let userDetails = JSON.parse(data[0].formDataEdit)
            console.log("userDetails-formDataEdit  : " + JSON.stringify(userDetails))
            setFormDataUser(userDetails)
            setCurrentSelectedUserFormDetails(userDetails);
            console.log('userDetails -->', userDetails.role)
        }
    }
    const [messagebar1, setmessagebar1] = useState(false);
    const [messagebar2, setmessagebar2] = useState(false);
    const handleBothSetMessage = () => {
        setmessagebar1(false);
        setmessagebar2(true);
    };
    const handleFilterArray = (): any => {
        const value1 = dropDownValue1;
        const value2 = dropDownValue2;
        // Check if the column is already filtered
        const columnExists = filterArray.some(filter => filter.startsWith(`${value1} :`));
        if (!columnExists) {
            const result = value1 + " : " + value2;
            setFilterArray([...filterArray, result]);
            setIsFilter(true);
            setLoading(true);
            setDropDownValue1('');
            setDropDownValue2('');
        }
    };
    const handleCloseFilter = (index: any): any => {
        console.log("clicked");
        const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
        setFilterArray(updatedArray);
        setDropDownValue1('');
        setDropDownValue2('');
    }
    useEffect(() => {
        if (filterArray.length > 0) {
            setResetDisabled(false)
        } else {
            setResetDisabled(true)
        }
    }, [filterArray])

    useEffect(() => {
        setUniqueColumn(uniquUSerType?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
        setStatusName(uniqueStatus?.map((item) => ({ key: item, label: <Caption1>{item == 1 ? 'Active' : 'Pending'}</Caption1> })) || []);
    }, [uniquUSerType, uniqueStatus]);

    const inputChange = (e: any) => {
        const enteredValue = e.target.value;
        console.log("entered value", enteredValue)
        let name = e.target.name;
        const regexS = /^[A-Za-z ]*$/;
        const regexSN = /^[A-Za-z0-9 ]*$/;
        const regexN = /^[A-Za-z0-9.,!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/;
        if (filterArray.some((filter) => filter.startsWith(`${dropDownValue1} :`))) {
            setErrorMessage(`${dropDownValue1} is already filtered.`);
            return;
        } else {
            setErrorMessage(''); // Clear the message if no issue
        }
        if (name === 'filter' && dropDownValue1 === ("Email")) {
            if (regexN.test(enteredValue)) {
                setDropDownValue2(enteredValue);
            }
        }
        if (name === 'filter' && dropDownValue1 === ("First Name") || dropDownValue1 === ("Last Name")) {
            if (regexS.test(enteredValue)) {
                setDropDownValue2(enteredValue);
            }
        }
        if (name === 'filter' && dropDownValue1 === ("User Type")) {
            if (regexSN.test(enteredValue)) {
                setDropDownValue2(enteredValue);
            }
        }

    }

    const jsonSchema1: RJSFSchema = {
        "type": "object",
        "properties": {
            "firstName": {
                "type": "string",
                "title": "First name",
            },
            "lastName": {
                "type": "string",
                "title": "Last name"
            },
            "emailid": {
                "type": "string",
                "format": "email",
                "title": "Email Id",
                "pattern": "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$"
            },
            "Tenant": {
                "type": "string",
                "title": "Tenant access",
                "enum": siteList.map((val: any) => val.sitename),
                "enumNames": siteList.map((val: any) => val.sitename)
            },
            "TimeZone": {
                "type": "string",
                "title": "Time zone"
            },
            "Security": {
                "type": "string",
                "title": "Security",
                "enum": [
                    "emailotp",
                    "none"
                ],
                "enumNames": [
                    "Email OTP",
                    "None"
                ]
            },
            "role": {
                "type": "string",
                "title": "Role",
                "enum": roleEnum,
                "enumNames": roleEnumNames
            }
        },
        "required": [
            "firstName",
            "lastName",
            "emailid",
            "Tenant",
            "role" // Make role required
        ]
    }

        ;

    const uiSchema1 = {

        "firstName": {

            "ui:widget": "text",

            "ui:required": true

        },

        "lastName": {

            "ui:widget": "text",

            "ui:required": true

        },

        "emailid": {
            "ui:widget": "text",
            "ui:required": true
        },
        'ui:submitButtonOptions': {
            norender: true,
        },

        "Tenant": {
            "ui:widget": "MultipleSelectToStringTanent"
        },

        "TimeZone": {
            "ui:widget": "TimezoneSelectWidget"
        },


    }

    //below uischema added to handle disabled state for firstName, lastName and Email
    const uiSchema2 = {

        "firstName": {

            "ui:widget": "text",

            "ui:required": true,

            "ui:disabled": true

        },

        "lastName": {

            "ui:widget": "text",

            "ui:required": true,

            "ui:disabled": true

        },

        "emailid": {

            "ui:widget": "text",

            "ui:required": true,

            "ui:disabled": true

        },
        'ui:submitButtonOptions': {
            norender: true,
        },

        "Tenant": {
            "ui:widget": "MultipleSelectToStringTanent"
        },

        "TimeZone": {
            "ui:widget": "TimezoneSelectWidget"
        },
    }

    // new uiSchema added to fix hover issue in the review form (NCP-3177 - When we hover on dropbox in review and create it gets highlighted for few parameters)
    const uiSchemaDisabled = {

        "firstName": {

            "ui:widget": "text",

            "ui:required": true,

            "ui:disabled": true

        },

        "lastName": {

            "ui:widget": "text",

            "ui:required": true,

            "ui:disabled": true

        },

        "emailid": {

            "ui:widget": "text",

            "ui:required": true,

            "ui:disabled": true

        },
        'ui:submitButtonOptions': {
            norender: true,
        },

        "Tenant": {
            "ui:widget": "MultipleSelectToStringTanent"
        },

        "TimeZone": {
            "ui:widget": "TimezoneSelectWidget"
        },
        "role": {
            "ui:style": {
                pointerEvents: 'none',
                backgroundColor: 'initial',
                color: 'initial',
                cursor: 'not-allowed',
            },
        },
        "Security": {
            "ui:style": {
                pointerEvents: 'none',
                backgroundColor: 'initial',
                color: 'initial',
                cursor: 'not-allowed',
            },
            'ui:autofocus': false,
        }
    }
    // below useEffect will handle setting uischema on rjsf form
    useEffect(() => {
        if (overlayOpen) {
            const element = document.getElementById("fluent-default-layer-host");
            if (element) {
                element.style.zIndex = '9999999';
            }
        }

        overlayName !== '' ? setUischema(uiSchema2) : setUischema(uiSchema1);
    }, [overlayOpen, overlayName])



    //data table column name code starts here
    // var columns = [
    //     { key: "firstname", label: <Body1Strong> First Name </Body1Strong> },
    //     { key: "lastname", label: <Body1Strong> Last Name</Body1Strong> },
    //     { key: "email", label: <Body1Strong>Email</Body1Strong> },
    //     { key: "usertype", label: <Body1Strong> User Type</Body1Strong> },
    //     { key: "createdon", label: <Body1Strong>Created On (UTC)</Body1Strong> },
    //     { key: "createdon_timezoned", label: <Body1Strong>Created On ({formattedTimeZone})</Body1Strong> },
    //     { key: "modifiedon", label: <Body1Strong>Modified On (UTC)</Body1Strong> },
    //     { key: "modifiedon_timezoned", label: <Body1Strong>Modified On ({formattedTimeZone})</Body1Strong> },
    //     { key: "status", label: <Body1Strong>Status</Body1Strong> },

    // ];
    // //data table column name code ends here
    // var columns1 = [
    //     { key: "firstname", label: <Caption1> First Name </Caption1> },
    //     { key: "lastname", label: <Caption1> Last Name</Caption1> },
    //     { key: "email", label: <Caption1>Email</Caption1> },
    //     { key: "usertype", label: <Caption1>User Type</Caption1> },
    //     { key: "createdon", label: <Caption1>Created On </Caption1> },
    //     { key: "modifiedon", label: <Caption1>Modified On </Caption1> },
    //     { key: "status", label: <Caption1>Status</Caption1> },
    // ];
    //data table for filter column starts here

    var tableColumns: any[] = [];
    var filterColumns: any[] = [];
    useEffect(() => {
        contextValue?.tableColumnsData?.Administration?.User.forEach((val) => {
            if (val.display.table.toLocaleLowerCase() === "yes" && val.priority >= 0) {
                if (val.key === "createdon_timezoned" || val.key === "modifiedon_timezoned") {
                    tableColumns[val.priority] = ({
                        key: val.key,
                        label:
                            <>
                                <Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }} horizontalAlign="center">
                                    <StackItem>
                                        <Body1Strong>{`${val.name}`}</Body1Strong>
                                    </StackItem>
                                    <StackItem align="center">
                                        <Tooltip withArrow content={`Timezone : ${formattedTimeZone}`} relationship="description" positioning="above">
                                            <Info16Filled style={{ display: "flex" }} {...timezoneInfo} />
                                        </Tooltip>
                                    </StackItem>
                                </Stack>
                            </>
                    });
                } else {
                    tableColumns[val.priority] = ({ key: val.key, label: <Body1Strong> {val.name} </Body1Strong> });
                }
            }

            if (val.display.filter.toLocaleLowerCase() === "yes") {
                filterColumns.push({ key: val.key, label: <Caption1> {val.name} </Caption1> });
            }
        });

        setTableColumnsData(tableColumns);
        setFilterColumnsData(filterColumns);

        contextValue.setManageViewDropDownData(contextValue?.tableColumnsData?.Administration?.User.filter((val) => val.priority >= 0));

        contextValue.setManageViewPageDetails({ module: "Administration", page: "User" });
    }, [contextValue.tableColumnsData]);



    // overflow set contents code starts here
    var overFlowComponent = {
        data:
            <>
                {permissions.includes("all") || permissions.includes("allUsers_Fullaccess") ?
                    <StackItem onClick={() => { setFormDataUser({}); setCurrentSelectedUserFormDetails({}); setOverlayOpen(true); setOverlayName(''); setSpinnerLoad(false); }}>
                        <Button disabled={loading} shape="circular" appearance="subtle" size="small" onClick={() => setCurrentPageNo(1)}>
                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                <StackItem> <AddSquare20Regular {...(loading ? secondaryIcon : primaryIcon)} /> </StackItem>
                                <StackItem> <Caption1> Create User </Caption1></StackItem>
                            </Stack>
                        </Button>
                    </StackItem>
                    :
                    <StackItem>
                        <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                            <Button shape="circular" appearance="subtle" size="small" disabled>
                                <Stack tokens={{ childrenGap: 5 }} horizontal>
                                    <StackItem><Text></Text></StackItem>
                                    <StackItem>
                                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                                            <StackItem> <AddSquare20Regular {...secondaryIcon} /> </StackItem>
                                            <StackItem><Caption1> Create User </Caption1></StackItem>
                                        </Stack>
                                    </StackItem>
                                </Stack>
                            </Button>
                        </Tooltip>
                    </StackItem>}

                <StackItem>
                    <Divider vertical />
                </StackItem>

                {/* <StackItem>
                    <DialogBox
                        headerButton={
                            <>
                                <Button shape="circular" appearance="transparent" size="small"
                                    disabled={isdeletedisabled ? true : false} >
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem>
                                            {isdeletedisabled
                                                ? (<KeyResetRegular {...secondaryIcon} />)
                                                : (<KeyResetRegular {...primaryIcon} />)
                                            }
                                        </StackItem>
                                        <StackItem> <Caption1> Reset Password </Caption1> </StackItem>
                                    </Stack>
                                </Button>
                            </>
                        }

                        content="Are you sure you want send the reset link to selected user"

                        footer=
                        {
                            <>
                                <Stack horizontal tokens={{ childrenGap: 10 }}>
                                    <StackItem>
                                        <Button shape="circular" appearance="primary" onClick={() => { sendResetEmail(); }} size="small">Confirm</Button>
                                    </StackItem>
                                    <StackItem>
                                        <Button shape="circular" size="small">Cancel</Button>
                                    </StackItem>
                                </Stack>
                            </>
                        }
                    />
                </StackItem> */}

                {/* <StackItem>
                    <Divider vertical />
                </StackItem> */}

                <StackItem>
                    <DialogBox
                        headerButton={
                            <>
                                <Button shape="circular" appearance="transparent" size="small"
                                    disabled={isdeletedisabled ? true : false} >
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem>
                                            {isdeletedisabled
                                                ? (<Delete20Regular {...secondaryIcon} />)
                                                : (<Delete20Regular {...primaryIcon} />)
                                            }
                                        </StackItem>
                                        <StackItem> <Caption1> Delete </Caption1> </StackItem>
                                    </Stack>
                                </Button>
                            </>
                        }

                        content="Are you sure you want to delete the user? This action cannot be reverted."

                        footer=
                        {
                            <>
                                <Stack horizontal tokens={{ childrenGap: 10 }}>
                                    <StackItem>
                                        <Button shape="circular" appearance="primary" onClick={() => { setdeleteUser(true);}} size="small">Confirm</Button>

                                        {/* <Button shape="circular" appearance="primary" onClick={() => {setDeleteAppMonitored(true)}} size="small">Confirm</Button> */}
                                    </StackItem>
                                    <StackItem>
                                        <Button shape="circular" size="small">Cancel</Button>
                                    </StackItem>
                                </Stack>
                            </>
                        }
                    />
                    {/* </Stack> */}
                    {/* </Button> */}
                </StackItem>

                <StackItem>
                    <Divider vertical />
                </StackItem>
                <StackItem>
                    <DialogBox
                        headerButton={
                            <>
                                <Button shape="circular" appearance="transparent" size="small"
                                    disabled={isdeletedisabled ? true : false} >
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem>
                                            {isdeletedisabled
                                                ? (<KeyReset20Regular {...secondaryIcon} />)
                                                : (<KeyReset20Regular {...primaryIcon} />)
                                            }
                                        </StackItem>
                                        <StackItem> <Caption1> Reset Password </Caption1> </StackItem>
                                    </Stack>
                                </Button>
                            </>
                        }

                        content="Are you sure you want to sent mail to the selected user."

                        footer=
                        {
                            <>
                                <Stack horizontal tokens={{ childrenGap: 10 }}>
                                    <StackItem>
                                        <Button shape="circular" appearance="primary" onClick={() => setMailSent(true)} size="small">Confirm</Button>
                                    </StackItem>
                                    <StackItem>
                                        <Button shape="circular" size="small">Cancel</Button>
                                    </StackItem>
                                </Stack>
                            </>
                        }
                    />
                </StackItem>

                <StackItem>
                    <Divider vertical />
                </StackItem>

                <StackItem>
                    <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => { setCurrentPageNo(1); setIsRefresh(true); setLoading(true) }}>
                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                            <StackItem>{loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />}</StackItem>
                            <StackItem> <Caption1> Refresh </Caption1> </StackItem>
                        </Stack>
                    </Button>
                </StackItem>
                {permissions.includes("all") || permissions.includes("allUsers_ReadandExport") || permissions.includes("allUsers_Fullaccess") ?
                    <StackItem>
                        <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_users.csv`}>
                        </CSVLink>
                        <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => { setExportBtnClicked(true) }}>
                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                <StackItem>{loading || tableData.length === 0 ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                                <StackItem> <Caption1> Export </Caption1> </StackItem>
                            </Stack>
                        </Button>
                    </StackItem>
                    :
                    <StackItem>
                        <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                            <Button shape="circular" appearance="subtle" size="small" disabled>
                                <Stack tokens={{ childrenGap: 5 }} horizontal>
                                    <StackItem><Text></Text></StackItem>
                                    <StackItem>
                                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                                            <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                                            <StackItem><Caption1> Export </Caption1></StackItem>
                                        </Stack>
                                    </StackItem>
                                </Stack>
                            </Button>
                        </Tooltip>
                    </StackItem>
                }

                <StackItem>
                    <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => document.getElementById("manageView").click()}>
                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                            <StackItem> {loading || tableData.length === 0 ? <Settings20Regular {...secondaryIcon} /> : <Settings20Regular {...primaryIcon} />} </StackItem>
                            <StackItem> <Caption1> Manage View </Caption1> </StackItem>
                        </Stack>
                    </Button>
                </StackItem>
                
                <StackItem grow shrink>
                    <Stack horizontalAlign="end">
                        <StackItem grow shrink>
                            <FullScreenButton handle={handle} />
                        </StackItem>
                    </Stack>
                </StackItem>
            </>
        ,
    };
    // overflow set contents code ends here

    var tempTableData: any = [];
    var menuLists: any = [];
    var tempExportData: any = [];
    useEffect(() => {
        var tempExportData: any = [];

        exportDetails?.length > 0 && exportDetails.map((val: any) => {
            // setUniqueUserType(val.userType)
            tempExportData.push({
                'First Name': val.firstName,
                'Last Name': val.lastName,
                'Email': val.user_email,
                'User Type': val.userType,
                'Created On': convertToExcelFormat(val.Created_on),
                'Status': val.status,
                'Modified On': convertToExcelFormat(val.modifiedOn)
            });
        });
        setExportBtnClicked(false);
        setExportData(tempExportData);
    }, [exportDetails]);

    // useEffect(() => {
    //   //roles and permissions
    //   async function loadRoute() {
    //     console.log("role:-",sessionStorage.getItem('role'))
    //     const role = sessionStorage.getItem('role');

    //     try {
    //       const [routeAllowed, permissions] = await shouldLoadRoute(role);

    //       if (routeAllowed) {
    //         console.log("permission===",permissions);
    //         setPermissions(permissions)
    //       } else {
    //         console.log('Route is not allowed.');
    //       }
    //     } catch (error) {
    //       console.error('Error loading route:', error);
    //     }
    //   }
    //   loadRoute();
    // }, []);

    useEffect(() => {
        if (final_data && Array.isArray(final_data)) {
            const newUniqueStatus: any = [];
            const newUniqueUsertype: any = [];
            final_data.forEach((val: any) => {
                if (newUniqueStatus.indexOf(val.userStatus) === -1) {
                    newUniqueStatus.push(val.userStatus);
                }
                if (val?.userType && val?.userType.trim() !== "-" && !newUniqueUsertype.includes(val?.userType)) {
                    newUniqueUsertype.push(val?.userType);
                }
            });
            console.log("Populated unique statuses: ", newUniqueStatus);
            setUniqueStatus(newUniqueStatus);
            setUniqueUserType(newUniqueUsertype);

        } else {
            setUniqueStatus([]);
            setUniqueUserType([]);

        }
    }, [final_data]);

    useEffect(() => {
        // Data table values append code starts here
        console.log("final_data USERS=", final_data);
        // getSiteList();
        // getRoles();
        final_data !== undefined && final_data !== null
            ? final_data?.map((val: any, i: any) => {
                // console.log("final data email--->", val.user_email);
                const email = val.user_email;
                const name = val.firstName;
                const truncateText = (text: string, limit: number) => {
                    const words = text;
                    const truncatedWords = words.slice(0, limit);
                    return truncatedWords + (text.length > limit ? '...' : '');
                };
                let formattedEmail: any = truncateText(email, 12)
                let formattedName: any = truncateText(name, 8)

                const uniqueTypes = Array.from(new Set(final_data.map(item => item.userType)));
                // setUniqueUserType(uniqueTypes);
                // console.log("formattedemail", formattedEmail) 
                // const formattedEmail = email.substring(0, 10) + "\n" + email.substring(10, 23) + "\n" + email.substring(23);
                // console.log("formattedEmail----->\n", formattedEmail);
                menuLists.push();
                {
                    permissions.includes("all") || permissions.includes("allUsers_Fullaccess") ?
                        tempTableData.push({
                            id: val.userid,
                            name: val.user_email,
                            checkbox: 'show',
                            firstname: {
                                label: <Button id="ButtonHover" title={name} style={buttonContent} appearance="transparent" size="small" onClick={() => {
                                    setRowID(val.userid); setOverlayName('edit'); setOverlayOpen(true); setSpinnerLoad(true);
                                }}> {formattedName} </Button>, icon: "", id: `${i}`
                            },
                            lastname: { label: <Caption1>  {val.lastName != "" ? val.lastName : "N/A"} {setRowDesc(val.lastName)}  </Caption1>, status: "" },
                            email: { label: <Caption1 title={email}> {formattedEmail} </Caption1> },
                            usertype: { label: <Caption1>{'\u00A0'.repeat(4)} {val?.userType ?? 'local'} </Caption1> },
                            createdon: { label: <Caption1> {(val.Created_on != null && val.Created_on !== '') ? convertUTCToReadableFormat(val.Created_on) : '-'} </Caption1> },
                            createdon_timezoned: { label: <Caption1> {(val.Created_on != null && val.Created_on !== '') ? convertToLocalTimezone(val.Created_on, userTimeZone) : '-'} </Caption1> },
                            modifiedon: { label: <Caption1> {(val.modifiedOn != null && val.modifiedOn !== '') ? convertUTCToReadableFormat(val.modifiedOn) : '-'} </Caption1> },
                            modifiedon_timezoned: { label: <Caption1> {(val.modifiedOn != null && val.modifiedOn !== '') ? convertToLocalTimezone(val.modifiedOn, userTimeZone) : '-'} </Caption1> },
                            status: { label: ((val.userStatus == 1)) ? <Caption1>Active</Caption1> : <Caption1>Pending</Caption1> },
                            passwordDate: { label: <Caption1> {(val.passwordDate != null && val.passwordDate !== '') ? convertUTCToReadableFormat(val.passwordDate) : '-'} </Caption1> },
                            loginDate: { label: <Caption1> {(val.loginDate != null && val.loginDate !== '') ? convertUTCToReadableFormat(val.loginDate) : '-'} </Caption1> },
                            securityType: { label: <Caption1> {val.securityType} </Caption1> },
                            login_attempts: { label: <Caption1> {val.login_attempts} </Caption1> },
                            role_assigned: { label: <Caption1> {val.role_assigned} </Caption1> },
                            tenant: { label: <Caption1> {val.tenant} </Caption1> },


                        }) :
                        tempTableData.push({
                            id: val.userid,
                            name: val.user_email,
                            checkbox: 'hide',
                            firstname: {
                                label:
                                    <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                                        <Caption1 > {val.firstName} </Caption1>
                                    </Tooltip>, icon: "", id: `${i}`
                            },
                            lastname: { label: <Caption1>  {val.lastName != "" ? val.lastName : "-"} {setRowDesc(val.lastName)}  </Caption1>, status: "" },
                            email: { label: <Caption1> {formattedEmail} </Caption1> },
                            usertype: { label: <Caption1>{'\u00A0'.repeat(4)} {val?.userType ?? 'local'} </Caption1> },
                            createdon: { label: <Caption1> {(val.Created_on != null && val.Created_on !== '') ? convertUTCToReadableFormat(val.Created_on) : '-'} </Caption1> },
                            createdon_timezoned: { label: <Caption1> {(val.Created_on != null && val.Created_on !== '') ? convertToLocalTimezone(val.Created_on, userTimeZone) : '-'} </Caption1> },
                            modifiedon: { label: <Caption1> {(val.modifiedOn != null && val.modifiedOn !== '') ? convertUTCToReadableFormat(val.modifiedOn) : '-'} </Caption1> },
                            modifiedon_timezoned: { label: <Caption1> {(val.modifiedOn != null && val.modifiedOn !== '') ? convertToLocalTimezone(val.modifiedOn, userTimeZone) : '-'} </Caption1> },
                            status: { label: ((val.userStatus == 1)) ? <Caption1>Active</Caption1> : <Caption1>Pending</Caption1> },
                        })
                }
            }) : (tempTableData = []);
        tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);
        // setLoading(false);
        setTimeout(() => {
            final_data !== undefined && final_data !== null && setLoading(false);
            if (isRefresh) {
                console.log("FIRST CALL");
                setIsRefresh(false);
                setRefreshToast(true);
                setTimeout(() => {
                setRefreshToast(false);
                }, 3000);
            }
        }, 500);
    }, [final_data, formDataUser, permissions, rowID]);
    // Data table values append code ends here
    useEffect(() => {
        exportData.length > 0 && document.getElementById('csv-export-link')?.click();
    }, [exportData]);

    const addAutoComplete = { autoComplete: 'off' }
    useEffect(() => {
        setoverLayData({
            // Here this is heading of the overlay
            headerTitle: overlayName == 'edit' ? <Title3>Edit User</Title3> : <Title3>Create User</Title3>,
            size: "large",
            isTabs: true,

            // This is button present in the overlay

            // Data presents in the overlay(overlay content)
            tabItems: {
                Introduction:spinnerLoad ?
                <Stack horizontal verticalAlign="center" horizontalAlign="center" style={DynamicBoxingCSS}>
                  <Spinner />
                </Stack> :
                    <FluentProvider theme={dashboardTheme}>
                        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
                            <Form {...addAutoComplete} ref={formRef} formData={formDataUser} schema={jsonSchema1} uiSchema={uischema} validator={validator} liveValidate={true} customValidate={overlayName !== 'edit' ? customValidate : undefined} transformErrors={transformErrors} widgets={CustomWidgets} onChange={(e) => setFormDataUser(e.formData)} />
                        </Stack>
                    </FluentProvider>,
                "Review Data":
                    <FluentProvider theme={dashboardTheme}>
                        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
                            <Form disabled={true} formData={formDataUser} schema={jsonSchema1} uiSchema={uiSchemaDisabled} validator={validator} widgets={CustomWidgets} onChange={(e) => setFormDataUser(e.formData)} />
                        </Stack>
                    </FluentProvider>
            },
        });
    }, [formDataUser, overlayName, CustomWidgets, spinnerLoad]);

    useEffect(() => {
        contextValue.setSelectedRowIdInTable([]);
        contextValue.setSelectedRowIdInSubTable([]);
    }, []);

    useEffect(() => {
        contextValue.selectedRowIdInTable.length > 0 ? setDeleteDisabled(false) : setDeleteDisabled(true);
    }, [contextValue.selectedRowIdInTable, contextValue.selectedRowIdInSubTable]);

    function customValidate(formData, errors, uiSchema) {
        // Check the existence of mail entered by user
        const exists = final_data?.some(user => user.user_email === formData.emailid);
        if (exists) {
            errors.addError("User already exists");
        }
        return errors;
    }

    const transformErrors = (errors) => {
        // Only transform errors if overlayName is not "edit"
        if (overlayName === 'edit') {
            return []; // Return an empty array to suppress all transformed errors
        }
        return errors.map(error => {
            return [];
        });
    };

    return (
        <>
            <FullScreen handle={handle} className="fullScreenBackgroundColor">
                <StackItem grow shrink style={BreadcrumbsBorder}>
                    <Stack tokens={{ childrenGap: 10 }} horizontal>
                        <StackItem grow shrink>
                            <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
                                <StackItem><Text></Text></StackItem>
                                <StackItem grow shrink>
                                    <Breadcrumbs
                                        items={[
                                            {name: "Manage", link: "/home" },
                                            {name:"Administration", link:"/manage/administration/role"},
                                            {name:"Users", link:"#"},
                                        ]} 
                                    /> 
                                </StackItem>
                            </Stack>
                        </StackItem>
                    </Stack>
                </StackItem>
                <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
                    <StackItem style={DynamicBoxingCSS}>
                        {/* pages code starts here */}
                        <Stack style={DynamicBoxingCSS}>
                            <FluentProvider style={parentHome} theme={dashboardTheme} >
                                <Stack style={parentHome} horizontal >
                                    <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={AdministrationPages("Users")} />
                                    <StackItem style={DynamicBoxingCSS}>
                                        <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                                            <StackItem>
                                                <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                                                <Divider />
                                            </StackItem>
                                            <StackItem>
                                                <StackItem style={wraperStyle}>
                                                    <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                                                        <Stack horizontal tokens={{ childrenGap: 10 }}>
                                                            <StackItem>
                                                                <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"First Name"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
                                                            </StackItem>
                                                            <StackItem>
                                                                <MenuDropdown open={filterMenuOpen} btn={
                                                                    <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                                                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                            {loading || tableData.length === 0 ? <Filter20Filled {...secondaryIcon} /> : <Filter20Filled {...primaryIcon} />}
                                                                            <Body1> Filter </Body1>
                                                                        </Stack>
                                                                    </MenuButton>
                                                                } itemVal={<><Body1Strong> Add a Filter </Body1Strong>
                                                                    <Divider />
                                                                    <MenuList>
                                                                        <Stack tokens={{ childrenGap: 5 }}>
                                                                            <StackItem> <Text /> </StackItem>
                                                                            <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                                                            <DropdownComponent optionData={filterColumnsData} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
                                                                            <StackItem> <Divider /> </StackItem>
                                                                            <StackItem> <Caption1> Value </Caption1> </StackItem>
                                                                            {(dropDownValue1 === 'Created On' || dropDownValue1 === 'Modified On') && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />))}
                                                                            {(dropDownValue1 === 'First Name' || dropDownValue1 === 'Last Name') && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<Input size="small" onChange={inputChange} name="filter" value={dropDownValue2} />))}
                                                                            {dropDownValue1 === "Status" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DropdownComponent optionData={isStatusName} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />))}
                                                                            {(dropDownValue1 === 'Email') && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
                                                                            {dropDownValue1 === 'User Type' && <DropdownComponent optionData={uniqueColumn} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />}
                                                                            <StackItem> <Divider /> </StackItem>
                                                                            <Stack tokens={{ childrenGap: 10 }} horizontal>
                                                                                <StackItem>
                                                                                    <Button shape="circular"
                                                                                        appearance="primary"
                                                                                        onClick={() => { handleFilterArray(); setFilterMenuOpen(false); }}
                                                                                        disabled={!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`))}
                                                                                    >  <Caption1> Apply </Caption1> </Button> </StackItem>
                                                                                <StackItem> <Button shape="circular" onClick={() => { setFilterMenuOpen(false); handleCloseFilter("") }} > <Caption1> Cancel </Caption1> </Button> </StackItem>
                                                                            </Stack>
                                                                        </Stack>
                                                                    </MenuList>
                                                                </>} />
                                                            </StackItem>
                                                            <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); }}>
                                                                <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                        <StackItem> <FilterDismiss20Filled /> </StackItem>
                                                                        <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                                                    </Stack>
                                                                </Button>
                                                            </StackItem>
                                                        </Stack>
                                                        {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                                                    </Stack>
                                                    <Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 0px' }}>
                                                        <StackItem>
                                                            {filterArray.length > 0 && (
                                                                <Stack horizontal wrap>
                                                                    {filterArray.map((item, index) => (
                                                                        <Button shape="circular" size="small">
                                                                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                                <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                                                                <StackItem>
                                                                                    <Stack tokens={{ childrenGap: 1 }}>
                                                                                        <StackItem><Text></Text></StackItem>
                                                                                        <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                                                                    </Stack>
                                                                                </StackItem>
                                                                            </Stack>
                                                                        </Button>
                                                                    ))}
                                                                </Stack>
                                                            )}
                                                        </StackItem>

                                                        <StackItem disableShrink>
                                                            {(tableData.length > 0 && !loading) && (
                                                                totalRecords > 0 &&
                                                                <Caption1>
                                                                    Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records
                                                                </Caption1>
                                                            )}
                                                        </StackItem>
                                                    </Stack>
                                                </StackItem>
                                            </StackItem>
                                            <Users_func
                                                filterArray={filterArray}
                                                data={final_data}
                                                func={set_final_data}
                                                searchVal={searchVal}
                                                pageNo={(currentPageNo - 1) * 50}
                                                setTotalPages={setTotalPages}
                                                setTotalRecords={setTotalRecords}
                                                isFilter={isfilter} dropDownValue1={dropDownValue1} setIsFilter={setIsFilter} dropDownValue2={dropDownValue2}
                                                saveUserDetails={saveUserDetails}
                                                setSaveUserDetails={setSaveUserDetails}
                                                formDataUser={formDataUser}
                                                setFormDataUser={setFormDataUser}
                                                deleteUser={deleteUser}
                                                setDeleteUser={setdeleteUser}
                                                setDeleteDisabled={setDeleteDisabled}
                                                setEditUserDetails={setEditUserDetails}
                                                editUserDetails={editUserDetails}
                                                rowId={rowID}
                                                setRowID={setRowID}
                                                handleEditData={handleEditData}
                                                currentSelectedUserFormDetails={currentSelectedUserFormDetails}
                                                setCurrentSelectedUserFormDetails={setCurrentSelectedUserFormDetails}
                                                setIsToast={setIsToast}
                                                isRefresh={isRefresh}
                                                setIsRefresh={setIsRefresh}
                                                setRefreshToast={setRefreshToast}
                                                setExportDetails={setExportDetails}
                                                deleteUserToast={deleteUserToast}
                                                setdeleteUserToast={setdeleteUserToast}
                                                setSiteList={setSiteList}
                                                setRoleList={setRoleList}
                                                setOverlayOpen={setOverlayOpen}
                                                setEmailExistsToast={setEmailExistsToast}
                                                exportBtnClicked={exportBtnClicked}
                                                setExportBtnClicked={setExportBtnClicked}
                                                tenant={tenantName}
                                                setLoading={setLoading}
                                                setMailSent={setMailSent} 
                                                isMailsent={isMailsent} 
                                                isMailSentToast={isMailSentToast} 
                                                setMailSentToast={setMailSentToast}
                                                setSpinnerLoad={setSpinnerLoad}
                                            />
                                            {tracker && <Activity_log_func data={userActivityData} setTracker={setTracker} type="insertLog" />}
                                            {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={tableColumnsData} setOverlayOpen={setOverlayOpen} ></DataTable>) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
                                        </Stack>
                                        {overlayName == 'edit' && editUserDetails && <ToastComponent setmessagebar={setIsToast} isToastEnabled={isToast} toastIntent="success" position="top-end" title="Success" message={"User Details Updated Successfully"} footer="" />}
                                        {overlayName != 'edit' && isToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={isToast} toastIntent="success" position="top-end" title="Success" message={"User Details Saved Successfully"} footer="" />}
                                        {deleteUserToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={isToast} toastIntent="success" position="top-end" title="Success" message={"User Detail Deleted Successfully"} footer="" />}
                                        {refreshToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}
                                        {isEmailExistsToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={isEmailExistsToast} toastIntent="warning" position="top-end" title="Failed" message={'Email already exists!'} footer="" />}
                                        {isMailSentToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={isToast} toastIntent="success" position="top-end" title="Success" message={"Mail sent Successfully"} footer="" />}

                                    </StackItem>
                                </Stack>
                            </FluentProvider>
                        </Stack>
                        <OverLay
                            overlayopen={overlayOpen}
                            setOverlayOpen={setOverlayOpen}
                            overlayData={overLayData}
                            isNavBtn={true}
                            saveBtnFunc={saveBtnFunc}
                            formRef={formRef}
                        />
                        <StackItem>
                            {messagebar1 && (
                                <ToastComponent setmessagebar={setmessagebar1}
                                    toastIntent="warning"
                                    position="top"
                                    title={`Are you sure you want to proceed with publishing this app on ${contextValue.selectedRowIdInTable.length} devices?`}
                                    footer={
                                        <>
                                            <Button shape="circular" appearance="primary" onClick={() => { setdeleteUser(true) }} > Confirm </Button>
                                            <Button shape="circular" onClick={() => { setmessagebar1(false); }} > Cancel </Button>
                                        </>
                                    }
                                />
                            )}
                        </StackItem>
                    </StackItem>
                    <StackItem><Text /></StackItem>
                </Stack>
            </FullScreen>
        </>
    );
};
